import { Button, Form, Input, Select } from "antd";
import axios from "axios";
import React, { useRef, useState } from "react";
import { jcTypeArray } from "../../utils";
import { useHistory, useParams } from "react-router";
import PolygonMap from "./PolygonMap";
const { Option } = Select;
const AddNeighborhood = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [type, setType] = useState();
  const route = useParams();
  const [form] = Form.useForm();
  const [polygonOne, setPolygonOne] = useState();

  console.log("get type:", type);
  const [childPoints, setChildPoints] = useState();
  const sendPoints = (points) => {
    setChildPoints(points);
  };

  const onSubmit = async (data) => {
    const readyData = data && {
      name: data.name,
      points: childPoints,
      type: data.type,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/neighborhood`,
        JSON.stringify(readyData),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        history.push("/neighborhood");
      }
    } catch (err) {
      if (!err?.response) {
      }
    }
  };

  const resetData = () => {
    setType("");
  };

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <div className="bg-white p-3">
          <div className="details-area" style={{ minHeight: 650 }}>
            <Form
              name="control-hooks"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              className="ant-form ant-form-vertical"
              onFinish={onSubmit}
              form={form} // like ref
              layout="vertical"
            >
              <PolygonMap childPoints={childPoints} sendPoints={sendPoints} />

              <div className="buttons-container">
                <Button
                  disabled={loading || !!error}
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                  className="add-submit-btn text-center mr-2"
                >
                  Submit
                </Button>

                <Button
                  type="ghost"
                  htmlType="button"
                  onClick={resetData}
                  className="reset-submit-btn text-center mr-2"
                >
                  Reset
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNeighborhood;
